import { Icon, Tag } from "pepsico-ds";

export const TABLE_CONFIG = {
  ROWS_PER_PAGE: 10,
  SEARCH_PLACEHOLDER: "Search by keyword name",
  NO_DATA_LABEL: "No keywords available",
};

export const HEADER_DATA = [
  {
    columnKey: "id",
    header: "ID",
    className: "text-center",
  },
  {
    columnKey: "name",
    header: "Name",
  },
  {
    columnKey: "slug",
    header: "Slug",
  },
  {
    columnKey: "type",
    header: "Type",
  },
  {
    columnKey: "status",
    header: "Status",
    className: "text-center",
  },
  {
    columnKey: "actions",
    header: "Actions",
    className: "text-center",
  },
];

export const STYLES = {
  slug: {
    backgroundColor: "#f5f5f5",
    padding: "2px 6px",
    borderRadius: "3px",
    fontSize: "12px",
  },
  actions: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    justifyContent: "center",
  },
  editIcon: {
    cursor: "pointer",
    color: "#007bff",
    fontSize: "16px",
  },
  deleteIcon: {
    cursor: "pointer",
    color: "#dc3545",
    fontSize: "16px",
  },
  disabledIcon: {
    cursor: "not-allowed",
    color: "#6c757d",
    fontSize: "16px",
    opacity: 0.5,
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "200px",
  },
};

export const MESSAGES = {
  EDIT_CONFIRMATION: (name) => `Edit keyword: ${name}`,
  DELETE_CONFIRMATION: "Are you sure you want to mark this keyword as deleted?",
  LOADING: "Loading keywords...",
  EDIT_TOOLTIP: "Edit keyword",
  DELETE_TOOLTIP: "Delete keyword",
  DELETE_DISABLED_TOOLTIP: "Cannot delete - already deleted",
};

export const TAG_COLORS = {
  ACTIVE: "Green-500",
  DELETED: "Red-500",
  TYPE: "Blue-500",
};

export const createSlugElement = (slug) => <code style={STYLES.slug}>{slug}</code>;

export const createTypeTag = (type) => (
  <Tag text={type} color={TAG_COLORS.TYPE} isCopyable={false} />
);

export const createStatusTag = (deleted) => (
  <Tag
    text={deleted ? "Deleted" : "Active"}
    color={deleted ? TAG_COLORS.DELETED : TAG_COLORS.ACTIVE}
    isCopyable={false}
  />
);

export const createActionButtons = (keyword, onEdit, onDelete) => (
  <div style={STYLES.actions}>
    <Icon
      icon="edit"
      onClick={() => onEdit(keyword)}
      style={STYLES.editIcon}
      title={MESSAGES.EDIT_TOOLTIP}
    />
    <Icon
      icon="delete"
      onClick={
        keyword.deleted ? undefined : () => onDelete(keyword.id, keyword.name)
      }
      style={keyword.deleted ? STYLES.disabledIcon : STYLES.deleteIcon}
      title={
        keyword.deleted ? MESSAGES.DELETE_DISABLED_TOOLTIP : MESSAGES.DELETE_TOOLTIP
      }
    />
  </div>
);
